import type { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

export function DialogFooter({ className, children }: ComponentProps<'div'>) {
  return (
    <div className={twMerge('flex flex-shrink-0 items-center justify-end gap-2 px-6 pb-6', className)}>{children}</div>
  )
}
